module.exports = __webpack_public_path__ + "img/docx.b1e12701.png";